import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import LayoutDesktop from "../../../layouts/LayoutDesktop";

import { db } from "../../../config/firebase";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";

function EditarFornecedor() {
  const { tema } = useTheme();
  const { usuario: usuarioLogado } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams(); // id do fornecedor

  const [nome, setNome] = useState("");
  const [contato, setContato] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [endereco, setEndereco] = useState("");
  const [fatura, setFatura] = useState(false);
  const [observacoes, setObservacoes] = useState("");

  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");

  useEffect(() => {
    async function carregarFornecedor() {
      if (!id) return;

      try {
        setCarregando(true);
        const ref = doc(db, "fornecedores", id);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setErro("Fornecedor não encontrado.");
          setCarregando(false);
          return;
        }

        const dados = snap.data();

        setNome(dados.nome || "");
        setContato(dados.contato || "");
        setTelefone(dados.telefone || "");
        setEmail(dados.email || "");
        setEndereco(dados.endereco || "");
        setFatura(!!dados.fatura);
        setObservacoes(dados.observacoes || "");
      } catch (e) {
        console.error(e);
        setErro("Erro ao carregar fornecedor.");
      } finally {
        setCarregando(false);
      }
    }

    carregarFornecedor();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    if (!nome.trim()) {
      setErro("Informe o nome do fornecedor.");
      return;
    }

    try {
      setSalvando(true);

      const ref = doc(db, "fornecedores", id);
      await updateDoc(ref, {
        grupoId: usuarioLogado?.grupoId || null,
        grupoNome: usuarioLogado?.grupoNome || usuarioLogado?.grupo || null,
        nome: nome.trim(),
        contato: contato.trim() || null,
        telefone: telefone.trim() || null,
        email: email.trim() || null,
        endereco: endereco.trim() || null,
        fatura: !!fatura,
        observacoes: observacoes.trim() || null,
        updatedAt: serverTimestamp(),
      });

      setSucesso("Fornecedor atualizado com sucesso!");
    } catch (e) {
      console.error(e);
      setErro("Erro ao salvar alterações.");
    } finally {
      setSalvando(false);
    }
  };

  if (carregando) {
    return (
      <LayoutDesktop tema={tema} titulo="Editar Fornecedor" subtitulo="">
        <p>Carregando dados do fornecedor...</p>
      </LayoutDesktop>
    );
  }

  return (
    <LayoutDesktop
      tema={tema}
      titulo="Editar Fornecedor"
      subtitulo={nome ? `Ajuste de dados do fornecedor ${nome}` : ""}
    >
      <section className="pc-card">
        <h2 style={{ marginTop: 0 }}>Dados do fornecedor</h2>

        {erro && (
          <div
            style={{
              marginTop: 12,
              padding: 8,
              borderRadius: 8,
              background: "#7f1d1d",
              color: "#fecaca",
              fontSize: 14,
            }}
          >
            {erro}
          </div>
        )}

        {sucesso && (
          <div
            style={{
              marginTop: 12,
              padding: 8,
              borderRadius: 8,
              background: "#14532d",
              color: "#bbf7d0",
              fontSize: 14,
            }}
          >
            {sucesso}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          style={{
            marginTop: 12,
            maxWidth: 720,
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          {/* Nome */}
          <label>
            <span style={{ fontSize: 14 }}>Nome</span>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
              }}
            />
          </label>

          {/* Contato */}
          <label>
            <span style={{ fontSize: 14 }}>Contato</span>
            <input
              type="text"
              value={contato}
              onChange={(e) => setContato(e.target.value)}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
              }}
            />
          </label>

          {/* Telefone */}
          <label>
            <span style={{ fontSize: 14 }}>Telefone</span>
            <input
              type="text"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
              }}
            />
          </label>

          {/* Email */}
          <label>
            <span style={{ fontSize: 14 }}>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
              }}
            />
          </label>

          {/* Endereço */}
          <label>
            <span style={{ fontSize: 14 }}>Endereço</span>
            <input
              type="text"
              value={endereco}
              onChange={(e) => setEndereco(e.target.value)}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
              }}
            />
          </label>

          {/* Fatura */}
          <label>
            <span style={{ fontSize: 14 }}>Fatura</span>
            <select
              value={fatura ? "sim" : "nao"}
              onChange={(e) => setFatura(e.target.value === "sim")}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
                color: "inherit",
              }}
            >
              <option value="nao">Não</option>
              <option value="sim">Sim</option>
            </select>
          </label>

          {/* Observações */}
          <label>
            <span style={{ fontSize: 14 }}>Observações</span>
            <textarea
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
              rows={3}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
                resize: "vertical",
              }}
            />
          </label>

          <div
            style={{
              marginTop: 14,
              display: "flex",
              gap: 10,
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              onClick={() => navigate("/cadastros/fornecedores")}
              className="pc-btn-secundario"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="pc-btn-primario"
              disabled={salvando}
            >
              {salvando ? "Salvando..." : "Salvar alterações"}
            </button>
          </div>
        </form>
      </section>
    </LayoutDesktop>
  );
}

export default EditarFornecedor;
